var _rect, _rect2, _rect3, _rect4, _rect5, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillpathTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 164,
    viewBox: "0 0 100 164",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 60,
    height: 20,
    rx: 4,
    fill: "#87D3F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 31.5,
    width: 99,
    height: 29,
    rx: 3.5,
    stroke: "#C4C4CD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 103.5,
    width: 99,
    height: 29,
    rx: 3.5,
    stroke: "#C4C4CD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 72,
    width: 60,
    height: 20,
    rx: 4,
    fill: "#87D3F2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 144,
    width: 60,
    height: 20,
    rx: 4,
    fill: "#87D3F2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50.5,
    y1: 22,
    x2: 50.5,
    y2: 29,
    stroke: "#C4C4CD"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50.5,
    y1: 63,
    x2: 50.5,
    y2: 70,
    stroke: "#C4C4CD"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 50.5,
    y1: 94,
    x2: 50.5,
    y2: 101,
    stroke: "#C4C4CD"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 50.5,
    y1: 135,
    x2: 50.5,
    y2: 142,
    stroke: "#C4C4CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillpathTemplate);
export default __webpack_public_path__ + "static/media/skillpath-template.bfe9a7302bbde8dc7ff60ecf3b81b039.svg";
export { ForwardRef as ReactComponent };